import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { NgForm } from "@angular/forms";

@Component({
  selector: "app-Resources",
  templateUrl: "./Resources.component.html",
  styleUrls: ["./Resources.component.scss"]
})
export class ResourcesComponent  implements OnInit {
  @ViewChild('Resourcesform')
  form: NgForm;
  filter: string = "";
  p: number = 1;
  data: Resource[];
  urlStart = "/assets/Resources/";
  @ViewChild("container") private container: ElementRef;

  constructor() {
    
    this.data = [
      {
        name:
          "COMING SOON - Data Dictionary",
        authors:
          "",
        source: "The Data Dictionary provides a comprehensive Excel-based guide to all data variables and terminology - each tab will be consistent with each data entry practices across C3PO sections.",
        date: "",
        pages: "",
        link: this.getUrl(""),
        eres: ""
      },
      {
        name:
          "C3PO Manual",
        authors:
          "",
        source: "The C3PO Manual offers a detailed PDF guide to data entry procedures, portal navigation, and website functionalities within the C3PO system.",
        date: "",
        pages: "",
        link: this.getUrl("C3PO_Website_Manual_V5.1"),
        eres: ""
      },
      {
        name:
          "Ped Cath Instructions",
        authors:
          "",
        source: "The Ped Cath Instructions outline the steps for running the Pedcath data package to help facilitate accurate and efficient data submission into C3PO.",
        date: "",
        pages: "",
        link: this.getUrl("PedCath_C3PO_guide"),
        eres: ""
      },
      {
        name:
          "Level 3 Tier AE Guide",
        authors:
          "",
        source: "The Level 3 Tier AE Guide is a PDF resource providing information and examples for Adverse Events classified from Level 1 to 5, with a specific focus on Level 3 tiers (3a, 3b, and 3c).",
        date: "",
        pages: "",
        link: this.getUrl("Level_3_Tier_AE_Guide"),
        eres: ""
      }
    ];
  }

  ngOnInit() {}

  scroll() {
    try {
      this.container.nativeElement.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } catch (err) {}
  }

  getUrl(link) {
    if (link == "") {
      return "javascript:void(0)";
    } else {
      return this.urlStart + link + ".pdf";
    }
  }
}

interface Resource {
  name: string;
  authors: string;
  source: string;
  date: string;
  pages: string;
  link: string;
  eres: string;
}
